module.exports = __webpack_public_path__ + "img/xianshang.f60b8d3e.png";